import React from 'react';

import { FormField } from '../../../client/forms/fields';
import { WidgetType } from '../../../client/forms/widgets';
import { TextWidgetComponent, NumberWidgetComponent } from '../../view/components/Forms';
import { CheckboxWidgetComponent } from '../../view/components/Forms/Widgets/CheckboxWidgetComponent';
import { ToggleWidgetComponent } from '../../view/components/Forms/Widgets/ToggleWidgetComponent';

export interface FieldComponentProps<T extends FormField = FormField> {
  field: T;
}

export type FieldComponent<T extends FormField = FormField> = React.FC<FieldComponentProps<T>>;

type WidgetNameType = keyof typeof WidgetType;

type ComponentMapType = {
  [K in WidgetNameType]: FieldComponent<
    Extract<
      FormField,
      {
        widget: {
          type: K;
        };
      }
    >
  >;
};

export const WidgetComponentMap: ComponentMapType = {
  [WidgetType.Text]: TextWidgetComponent,
  [WidgetType.Number]: NumberWidgetComponent,
  [WidgetType.Toggle]: ToggleWidgetComponent,
  [WidgetType.Checkbox]: CheckboxWidgetComponent,
};
